export default "__VITE_PUBLIC_ASSET__82144771__"